module.exports = __webpack_public_path__ + "static/media/shelf.b9dc1b48.svg";